import clsx from 'clsx';

import styles from './IconButton.module.scss';
import { DesignSystemIconSize, DesignSystemIconTone } from '../Icon/utils';

export enum DesignSystemIconButtonVariant {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  GHOST = 'ghost',
  DESTRUCTIVE = 'destructive',
}

export enum DesignSystemIconButtonSize {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}

type GetIconButtonClassesOptions = {
  variant?: DesignSystemIconButtonVariant;
  size?: DesignSystemIconButtonSize;
  isActive?: boolean;
  isLoading?: boolean;
  disabled?: boolean;
  className?: string;
};

const iconSizeByButtonSize: Record<
  DesignSystemIconButtonSize,
  DesignSystemIconSize
> = {
  [DesignSystemIconButtonSize.SMALL]: DesignSystemIconSize.SMALL,
  [DesignSystemIconButtonSize.MEDIUM]: DesignSystemIconSize.MEDIUM,
  [DesignSystemIconButtonSize.LARGE]: DesignSystemIconSize.LARGE,
};

export const getIconButtonIconSize = (
  size = DesignSystemIconButtonSize.MEDIUM,
): DesignSystemIconSize => {
  return iconSizeByButtonSize[size];
};

export const getIconButtonIconTone = ({
  variant = DesignSystemIconButtonVariant.GHOST,
  disabled,
}: {
  variant?: DesignSystemIconButtonVariant;
  disabled?: boolean;
}): DesignSystemIconTone => {
  if (disabled) {
    return DesignSystemIconTone.DISABLED;
  }

  if (variant === DesignSystemIconButtonVariant.PRIMARY) {
    return DesignSystemIconTone.ON_COLOR;
  }

  if (variant === DesignSystemIconButtonVariant.DESTRUCTIVE) {
    return DesignSystemIconTone.DANGER;
  }

  return DesignSystemIconTone.PRIMARY;
};

export const getIconButtonClasses = ({
  variant = DesignSystemIconButtonVariant.GHOST,
  size = DesignSystemIconButtonSize.MEDIUM,
  isActive,
  isLoading,
  disabled,
  className,
}: GetIconButtonClassesOptions): string => {
  const shouldBeDisabled = Boolean(disabled || isLoading);

  return clsx(
    styles.button,
    styles[variant],
    styles[size],
    {
      [styles.is_active]: isActive,
      [styles.is_loading]: isLoading,
      [styles.is_disabled]: shouldBeDisabled,
    },
    className,
  );
};
